module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-consumption"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 5,
      "sm": 5,
      "md": 3,
      "lg": 3
    }
  }, [_c('total-consumption', {
    attrs: {
      "data": _vm.totalConsumption
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 5,
      "sm": 5,
      "md": 3,
      "lg": 3
    }
  }, [_c('div', {
    staticClass: "avg-info"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('i', {
    staticClass: "el-icon-fa-bolt icon-large"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "consumption"
  }, [_vm._v("\n            " + _vm._s(_vm.totalAvgConsumption) + "kWh\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-label"
  }, [_vm._v("Total Average Usage")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 14,
      "sm": 14,
      "md": 18,
      "lg": 18
    }
  }, [_c('avgConsumption', {
    attrs: {
      "data": _vm.avgSeries
    }
  })], 1)], 1), _vm._v(" "), _c('highstock', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.chartLoading),
      expression: "chartLoading"
    }],
    ref: "stockChart",
    attrs: {
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Power Consumption\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d471b780","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/FieldsConsumption.vue
// module id = 944
// module chunks = 6